export default __webpack_public_path__ + "static/media/logow.fa9abebb.webp";